import React, { Suspense, useEffect, useState } from "react";
import { Route, Routes, useSearchParams, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import Sidebar from "./Components/Sidebar/Sidebar";
import Topbar from "./Components/Topbar/Topbar";
import User from "./Pages/IAM/User/User";
import Organizations from "./Pages/Providers/Organizations/Organizations";
import Locations from "./Pages/Providers/Locations/Locations";
import Patient from "./Pages/Apps/Patient/Circle/Circle";
import toast, { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "./redux/profile/profileSlice";
import Cookies from "js-cookie";
import routes from "./routes/routes";
import ProtectedRoute from "./routes/ProtectedRoute";
import Loading from "./Components/Common/Loading";
import Roles from "./Pages/IAM/Roles/Roles";
import Loader from "./Components/Common/Loader";

function App() {
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  // eslint-disable-next-line
  const [isOpen, setIsOpen] = useState(false);
  const accessToken =  searchParams.get("vt") || Cookies.get("Token");
  const userId      =  searchParams.get("ui") || Cookies.get("UserId");
  const tenantId    =  searchParams.get("ti") || Cookies.get("TenantId");

  const { profileData,error } = useSelector((state) => state.profile);
 
  const location=  useLocation()
  const navigate= useNavigate()
  useEffect(()=>{
    const ports = {
      '/': 'Home - Admin',
      '/workSpace/workflows': 'WorkSpace-WorkFlows - Admin',
      '/workSpace/workforms': 'WorkSpace-WorkForms - Admin',
      '/workSpace/workstates': 'WorkSpace-WorkStates - Admin',
      '/iam/roles': 'IAM-Roles - Admin',
      '/iam/groups': 'IAM-Groups - Admin',
      '/iam/users':'IAM-Users - Admin',
      '/apps/patient/circle':'Apps-Patient-Circle - Admin',
      '/providers/organizations':'Provicers-Organizations - Admin',
      '/providers/locations': 'Providers-Location - Admin',
      '/providers/agreements': 'Providers-Agreements - Admin',
      '/providers/ward': 'Providers-Ward - Admin',
      '/patners/agreement': 'Patners-Agreement - Admin',
      '/patients': 'Patients - Admin',
      '/apps/practitioner/roster': 'Apps-Practitioner-Roster - Admin',
      '/apps/studio': 'Apps-Studio - Admin',
      '/apps/admin': 'Apps-Admin - Admin',
      '/trust': 'Trust - Admin',
      '/billing': 'Billing - Admin',
      '/support': 'Support - Admin',
      '/general/departments': 'General-Departments - Admin',
      '/general/services': 'General-Services - Admin',
      '/general/appointments': 'General-Appointments - Admin',
      '/general/tariff': 'General-Tariff - Admin',
      '/general/diagnostic': 'General-Diagnostic - Admin',
      '/general/medicines': 'General-Medicines - Admin',
      '/general/vitals': 'General-Vitals - Admin',
      '/iam/roles/practitionerpermisson': 'IAM-Roles-PractitionerPermission - Admin',
      '/iam/roles/adminPermission': 'IAM-Roles-AdminPermission - Admin',
      '/dashboard': 'Dashboard - Admin',
      '/unauthorized': 'Unauthorized - Admin',
      '*': 'NotFound - Admin',
    };
    
    const currentTitle =  ports[location.pathname] || 'Admin'
    document.title =  currentTitle

  },[location])

  useEffect(() => {
    if (userId && accessToken && tenantId && !profileData) {
      dispatch(fetchUserProfile({ userId, accessToken, tenantId,navigate }));
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    // eslint-disable-next-line
  }, [userId, accessToken, tenantId, dispatch]);

  const toggleCreateProviderForm = () => {
    setShowForm((prevShowForm) => !prevShowForm);
  };


  useEffect(() => {
    const handleRouteChange = () => {
      navigate(window.location.pathname);  
    };

    window.addEventListener("customRouteChange", handleRouteChange);

    return () => {
      window.removeEventListener("customRouteChange", handleRouteChange);
    };
  }, [navigate]);

 
  if(error){
    toast.error(error)
  }
   


  return loading && !profileData ? (
    <div className="w-full h-screen border border-red-300">
    <Loader/>
    </div>
  ) : (
    <div className="flex h-[100vh] bg-canvas text-slate-900">
      <Toaster position="top-center" reverseOrder={false} />
      <Sidebar setShowForm={setShowForm} isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      <div className="flex h-[100vh] min-w-0 flex-1 flex-col overflow-hidden">
        <Topbar
          toggleCreateProviderForm={toggleCreateProviderForm}
          showForm={showForm}
          onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}
        />
        <main className="customScrollbar flex-1 overflow-y-auto p-4 sm:p-6">
          <div
            className={
              ["/dashboard", "/subscription"].includes(location.pathname)
                ? "mx-auto w-full max-w-[1400px]"
                : "mx-auto min-h-full w-full max-w-[1400px] overflow-hidden rounded-xl border border-slate-200 bg-white shadow-card"
            }
          >
            <Suspense fallback={<Loader/>}>
              <Routes>
                <Route
                  path="/iam/users"
                  element={
                    <ProtectedRoute>
                      <User
                        showForm={showForm}
                        toggleCreateProviderForm={toggleCreateProviderForm}
                      />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/iam/roles"
                  element={
                    <Roles
                      showForm={showForm}
                      toggleCreateProviderForm={toggleCreateProviderForm}
                    />
                  }
                />

                <Route
                  path="/providers/locations"
                  element={
                    <ProtectedRoute>
                      <Locations
                        showForm={showForm}
                        toggleCreateProviderForm={toggleCreateProviderForm}
                      />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/apps/patient/circle"
                  element={
                    <ProtectedRoute>
                      <Patient
                        toggleCreateProviderForm={toggleCreateProviderForm}
                        showForm={showForm}
                        setShowForm={setShowForm}
                      />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/providers/organizations"
                  element={
                    <ProtectedRoute>
                      <Organizations showForm={showForm} />
                    </ProtectedRoute>
                  }
                />

                {routes.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.component}
                  />
                ))}
              </Routes>
            </Suspense>
          </div>
        </main>
      </div>
    </div>
  );
}

export default App;
